import { User, Text, TextDetail } from "./models";

export default {
  users: {
    me: (): Promise<User> => api("get", "/users/me"),
  },
  cards: {
    del: (id: number) => api("delete", `/cards/${id}`),
    update: (id: number, question: string, answer: string) =>
      api("PATCH", `/cards/${id}`, { question, answer }),
  },
  texts: {
    create: (
      kind: "text" | "pov",
      body: string,
      lang?: string
    ): Promise<Text | { errors: string[] }> => {
      const params: Record<string, string> = { kind, body };

      if (lang) {
        params["target_lang"] = lang;
      }

      return api("post", "/texts", params);
    },
    list: (
      kind: "text" | "pov" = "text"
    ): Promise<Text[] | { errors: string[] }> => api("get", "/texts", { kind }),
    get: (uid: string): Promise<TextDetail | { errors: string[] }> => {
      return api("get", `/texts/${uid}`);
    },
    enqueue: (uid: string): Promise<Text | { errors: string[] }> => {
      return api("post", `/texts/${uid}/enqueue`);
    },
  },
};

type FetchParams = Parameters<typeof fetch>[1];

async function api(
  method: string,
  url: string,
  data?: { [k: string]: string }
) {
  const attrs: FetchParams = {
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  if (data) {
    if (method === "get") {
      url = `${url}?${toQuery(data)}`;
    } else {
      attrs.body = JSON.stringify(data);
    }
  }

  // csrf
  const meta = document.querySelectorAll<HTMLMetaElement>(
    "[name='csrf-token']"
  )[0];
  if (meta) {
    // @ts-ignore
    attrs.headers["X-CSRF-Token"] = meta.content;
  }

  return fetch(`/api${url}`, attrs).then((x) => x.json());
}

function toQuery(data: { [k: string]: string }) {
  const esc = window.encodeURIComponent;
  return (
    Object.keys(data)
      // @ts-ignore
      .map((k) => esc(k) + "=" + esc(data[k]))
      .join("&")
  );
}
